module.exports = __webpack_public_path__ + "img/扫码@2x.ce342732.png";